/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabItemMeasure from './lab-item-measure';
import LabItemMeasureDetail from './lab-item-measure-detail';
import LabItemMeasureUpdate from './lab-item-measure-update';
import LabItemMeasureDeleteDialog from './lab-item-measure-delete-dialog';

const LabItemMeasureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabItemMeasure />} />
    <Route path="new" element={<LabItemMeasureUpdate />} />
    <Route path=":id">
      <Route index element={<LabItemMeasureDetail />} />
      <Route path="edit" element={<LabItemMeasureUpdate />} />
      <Route path="delete" element={<LabItemMeasureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabItemMeasureRoutes;
